var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rules"},_vm._l((_vm.contacList),function(item,index){return _c('div',{key:index},[_c('div',{domProps:{"innerHTML":_vm._s(item.award1)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }